"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBlockSchema = void 0;
exports.InfoBlockSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/info-block.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "InfoBlock",
    "description": "Provide guidance or information",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:info-block"
            ]
        },
        "label": {
            "description": "Concise kicker text that supports the title and teaser. Example: Step 1 or Prize for the Finalists",
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "title": {
            "description": "The title of an info block. Example: Sign up or Playstation 5",
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "description": {
            "description": "Brief glimpse that describes the content in a bit more detail. Example: Win the brand new PS5 to dive even deeper into Esports.",
            "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
        },
        "url": {
            "description": "Link that directs the user to additional information, external resources, or actions related to the info block. Example: https://www.playstation.com/en-us/ps5/",
            "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json"
        },
        "image": {
            "description": "Image or illustration to provide visual context or make the information more engaging",
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "data": {
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
                }
            }
        }
    },
    "required": [
        "title",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2luZm8tYmxvY2suc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsZUFBZSxHQUFHO0lBQzdCLEtBQUssRUFBRSxtRUFBbUU7SUFDMUUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsV0FBVztJQUNwQixhQUFhLEVBQUUsaUNBQWlDO0lBQ2hELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVCQUF1QjthQUN4QjtTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsYUFBYSxFQUFFLG9HQUFvRztZQUNuSCxNQUFNLEVBQUUsNkRBQTZEO1NBQ3RFO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsYUFBYSxFQUFFLCtEQUErRDtZQUM5RSxNQUFNLEVBQUUsNkRBQTZEO1NBQ3RFO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsYUFBYSxFQUFFLGlJQUFpSTtZQUNoSixNQUFNLEVBQUUsbUZBQW1GO1NBQzVGO1FBQ0QsS0FBSyxFQUFFO1lBQ0wsYUFBYSxFQUFFLGlLQUFpSztZQUNoTCxNQUFNLEVBQUUsaUVBQWlFO1NBQzFFO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsYUFBYSxFQUFFLHVGQUF1RjtZQUN0RyxNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSxzRUFBc0U7aUJBQy9FO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsT0FBTztRQUNQLE1BQU07S0FDUDtDQUNGLENBQUEifQ==